"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ColorUtils_1 = require("../../../tree/ColorUtils");
const WebGLDefaultShader_1 = require("./WebGLDefaultShader");
class WebGLOutlineShader extends WebGLDefaultShader_1.WebGLDefaultShader {
    constructor(context) {
        super(context);
        this._width = 5;
        this._col = 0xffffffff;
        this._color = [1, 1, 1, 1];
    }
    set width(v) {
        this._width = v;
        this.redraw();
    }
    get width() {
        return this._width;
    }
    get color() {
        return this._col;
    }
    set color(v) {
        if (this._col !== v) {
            const col = ColorUtils_1.ColorUtils.getRgbaComponentsNormalized(v);
            col[0] = col[0] * col[3];
            col[1] = col[1] * col[3];
            col[2] = col[2] * col[3];
            this._color = col;
            this.redraw();
            this._col = v;
        }
    }
    useDefault() {
        return this._width === 0 || this._color[3] === 0;
    }
    setupUniforms(operation) {
        super.setupUniforms(operation);
        const gl = this.gl;
        this._setUniform("color", new Float32Array(this._color), gl.uniform4fv);
    }
    enableAttribs() {
        super.enableAttribs();
        this.gl.enableVertexAttribArray(this._attrib("aCorner"));
    }
    disableAttribs() {
        super.disableAttribs();
        this.gl.disableVertexAttribArray(this._attrib("aCorner"));
    }
    setExtraAttribsInBuffer(operation) {
        let offset = operation.extraAttribsDataByteOffset / 4;
        const floats = operation.quadList.floats;
        const length = operation.length;
        for (let i = 0; i < length; i++) {
            const elementCore = operation.getElementCore(i);
            // We are setting attributes such that if the value is < 0 or > 1, a border should be drawn.
            const ddw = this._width / elementCore.getLayoutW();
            const dw = ddw / (1 - 2 * ddw);
            const ddh = this._width / elementCore.getLayoutH();
            const dh = ddh / (1 - 2 * ddh);
            // Specify all corner points.
            floats[offset] = -dw;
            floats[offset + 1] = -dh;
            floats[offset + 2] = 1 + dw;
            floats[offset + 3] = -dh;
            floats[offset + 4] = 1 + dw;
            floats[offset + 5] = 1 + dh;
            floats[offset + 6] = -dw;
            floats[offset + 7] = 1 + dh;
            offset += 8;
        }
    }
    beforeDraw(operation) {
        const gl = this.gl;
        gl.vertexAttribPointer(this._attrib("aCorner"), 2, gl.FLOAT, false, 8, this.getVertexAttribPointerOffset(operation));
    }
    getExtraAttribBytesPerVertex() {
        return 8;
    }
}
exports.WebGLOutlineShader = WebGLOutlineShader;
WebGLOutlineShader.prototype.vertexShaderSource = `
    #ifdef GL_ES
    precision lowp float;
    #endif
    attribute vec2 aVertexPosition;
    attribute vec2 aTextureCoord;
    attribute vec4 aColor;
    attribute vec2 aCorner;
    uniform vec2 projection;
    varying vec2 vTextureCoord;
    varying vec2 vCorner;
    varying vec4 vColor;
    void main(void){
        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);
        vTextureCoord = aTextureCoord;
        vCorner = aCorner;
        vColor = aColor;
        gl_Position.y = -sign(projection.y) * gl_Position.y;
    }
`;
WebGLOutlineShader.prototype.fragmentShaderSource = `
    #ifdef GL_ES
    precision lowp float;
    #endif
    varying vec2 vTextureCoord;
    varying vec4 vColor;
    varying vec2 vCorner;
    uniform vec4 color;
    uniform sampler2D uSampler;
    void main(void){
        vec2 m = min(vCorner, 1.0 - vCorner);
        float value = step(0.0, min(m.x, m.y));
        gl_FragColor = mix(color, texture2D(uSampler, vTextureCoord) * vColor, value);
    }
`;
//# sourceMappingURL=WebGLOutlineShader.js.map